module.exports = __webpack_public_path__ + "static/media/mazya final edit shot 04 night.60262588.webp";